module.exports = __webpack_public_path__ + "static/media/tap-p.0a0703d9.mp3";